var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"mixerTimeline",staticClass:"mixer-timeline",style:({
    width: _vm.isTimelineScrollbarVisible
      ? 'calc(' + _vm.zoom + '% - 15px)'
      : 'calc(' + _vm.zoom + '% - 20px)',
    margin: _vm.isTimelineScrollbarVisible ? '0 5px 0 10px' : '0 10px',
  })},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mixedParts.length !== 0),expression:"mixedParts.length !== 0"}],ref:"mixerTimelinePlayheadContainer",staticClass:"mixer-timeline__playhead-container",style:({
      width: _vm.isTimelineScrollbarVisible ? '100%' : '100%',
    })},[_c('div',{staticClass:"mixer-timeline__playhead-container__playhead"},[_c('div',{staticClass:"mixer-timeline__playhead-container__playhead__pointer",style:({
          left:
            'calc(' +
            (_vm.contentVideoCurrentTime * 100) / _vm.mixedPartsDuration +
            '% - 8px + ' +
            _vm.currentMovmentXToShow +
            'px)',
        }),on:{"mousedown":_vm.startDragPlayhead}}),_c('div',{staticClass:"mixer-timeline__playhead-container__playhead__line",style:({
          left:
            'calc(' +
            (_vm.contentVideoCurrentTime * 100) / _vm.mixedPartsDuration +
            '% - 1px + ' +
            _vm.currentMovmentXToShow +
            'px)',
        })})])]),_c('div',{staticClass:"mixer-timeline__scale",style:({ opacity: _vm.mixedParts.length === 0 ? 0 : 1 }),on:{"click":_vm.seekTime}},_vm._l((Array(Math.ceil(_vm.mixedPartsDuration + 1))),function(point,i){return _c('div',{key:i,staticClass:"mixer-timeline__scale__point",style:({
        left: (i / _vm.mixedPartsDuration) * 100 + '%',
      })},[_c('div',{staticClass:"mixer-timeline__scale__point__line"}),_vm._v(" "+_vm._s(i % 5 === 0 ? i : " ")+" ")])}),0),_c('div',{staticClass:"mixer-timeline__preview",staticStyle:{"display":"flex","flex-direction":"row","align-items":"center","justify-content":"center"},on:{"click":_vm.seekTime}},[_c('draggable',_vm._b({staticStyle:{"display":"flex","flex-direction":"row","width":"100%","height":"100%"},style:(_vm.mixedParts.length === 0
          ? {
              border: '1px dashed #BEBEBE',
              borderRadius: '4px',
              alignItems: 'center',
              justifyContent: 'center',
              borderColor: _vm.dragOver ? '#bebebe' : '#6c6c6c',
            }
          : {}),attrs:{"list":_vm.mixedParts,"group":"parts"},on:{"start":function () {
          _vm.drag = true;
        },"end":function () {
          _vm.drag = false;
        }}},'draggable',_vm.dragOptions,false),[_c('transition-group',{staticStyle:{"display":"flex","flex-direction":"row","width":"100%","height":"100%"},attrs:{"type":"transition","name":!_vm.drag ? 'flip-list' : null},nativeOn:{"dragover":function($event){return (function () {
            _vm.dragOver = true;
          })($event)},"dragend":function($event){return (function () {
            _vm.dragOver = false;
          })($event)},"dragleave":function($event){return (function () {
            _vm.dragOver = false;
          })($event)}}},_vm._l((_vm.mixedParts),function(part,i){return _c('div',{key:part.id + i,staticClass:"mixer-timeline__preview__part",style:({
            width:
              (100 * (part.finishTime - part.startTime)) /
                _vm.mixedPartsDuration +
              '%',
            border:
              '2px solid ' +
              _vm.getLightenDarkenColor(part.parentItemInfo.color, -50),
            backgroundColor: _vm.getLightenDarkenColor(
              part.parentItemInfo.color,
              20
            ),
          })},[(!_vm.isShowChart)?_c('div',{staticClass:"mixer-timeline__preview__part__preview",style:({
              backgroundColor: _vm.getLightenDarkenColor(
                part.parentItemInfo.color,
                30
              ),
            })},_vm._l((_vm.getPartThumbs(part)),function(thumb){return _c('div',{key:thumb,style:({
                width: 100 / _vm.getPartThumbs(part).length + '%',
                height: '100%',
              })},[_c('img',{staticStyle:{"object-fit":"cover","height":"100%","width":"100%","pointer-events":"none"},attrs:{"src":thumb,"alt":""}})])}),0):_vm._e(),_c('div',{staticClass:"mixer-timeline__preview__part__title",style:({
              backgroundColor: _vm.getLightenDarkenColor(
                part.parentItemInfo.color,
                30
              ),
              color: _vm.getLightenDarkenColor(part.parentItemInfo.color, -50),
            }),attrs:{"title":part.name +
              ': ' +
              (part.finishTime - part.startTime).toFixed(2) +
              's'}},[_c('span',{staticClass:"mixer-timeline__preview__part__title__name"},[_vm._v(_vm._s(part.name))]),_c('span',{staticClass:"mixer-timeline__preview__part__title__duration"},[_vm._v(_vm._s((part.finishTime - part.startTime).toFixed(2) + "s")+" ")]),_c('div',{staticClass:"mixer-timeline__preview__part__title__edit-button",style:({
                backgroundColor: _vm.getLightenDarkenColor(
                  part.parentItemInfo.color,
                  30
                ),
              }),on:{"click":function($event){return _vm.onEditPart(part)}}},[_c('div',{staticClass:"icon",style:({
                  backgroundColor: _vm.getLightenDarkenColor(
                    part.parentItemInfo.color,
                    -50
                  ),
                })})]),_c('div',{staticClass:"mixer-timeline__preview__part__title__delete-button",style:({
                backgroundColor: _vm.getLightenDarkenColor(
                  part.parentItemInfo.color,
                  30
                ),
              }),on:{"click":function($event){return _vm.onDeletePart(part, i)}}},[_c('div',{staticClass:"icon",style:({
                  backgroundColor: _vm.getLightenDarkenColor(
                    part.parentItemInfo.color,
                    -50
                  ),
                })})])])])}),0)],1),(_vm.mixedParts.length === 0)?_c('div',{staticStyle:{"position":"absolute","color":"#6c6c6c","font-weight":"500","font-size":"15px","display":"flex","flex-direction":"row","align-items":"center","justify-content":"center","pointer-events":"none"},style:({ color: _vm.dragOver ? '#bebebe' : '#6c6c6c' })},[_c('div',{staticClass:"drag-here-icon",staticStyle:{"margin-right":"5px"}},[_c('div',{staticClass:"icon",style:({ backgroundColor: _vm.dragOver ? '#bebebe' : '#6c6c6c' })})]),_vm._v(" Drag your parts here ")]):_vm._e()],1),_c('div',{staticClass:"mixer-timeline__rows"},[_c('div',{staticClass:"mixer-timeline__rows__row"},[(!_vm.audioParameters.musicFile)?_c('div',{staticClass:"mixer-timeline__rows__row__add-music-button",staticStyle:{"display":"flex","justify-content":"space-between","font-size":"13px"},style:({
          left: 0,
          width: 100 + '%',
        }),on:{"click":_vm.onAddMusicFile}},[_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s("+ Add music"))]),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":".mp3, .wav"},on:{"change":_vm.onFileChanged}})]):_vm._e(),(_vm.audioParameters.musicFile)?_c('div',{staticClass:"mixer-timeline__rows__row__music-part",staticStyle:{"display":"flex","justify-content":"space-between","font-size":"13px"},style:({
          left: 0,
          width:
            (_vm.audioParameters.musicFile.duration * 100) / _vm.mixedPartsDuration +
            '%',
          maxWidth: '100%',
        })},[_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(_vm.audioParameters.musicFile.name))]),_c('div',{staticStyle:{"margin-right":"5px"}},[_c('span',{staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(_vm.audioParameters.musicFile.duration)+"s")]),_c('div',{staticClass:"mixer-timeline__rows__row__music-part__delete-button",on:{"click":_vm.deleteMusic}},[_c('div',{staticClass:"icon"})])])]):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }